import DashboardLayout from '../layout/DashboardLayout.vue'
// GeneralViews
import NotFound from '../pages/NotFoundPage.vue'

// Admin pages
import Overview from 'src/pages/Overview.vue'
import UserProfile from 'src/pages/UserProfile.vue'
import CreateClient from 'src/pages/CreateClient.vue'
import Campaigns from 'src/pages/Campaigns.vue'
import Campaign from 'src/pages/Campaign.vue'
import CreateCampaign from 'src/pages/CreateCampaign.vue'
import CreateUser from 'src/pages/CreateUser.vue'
import Typography from 'src/pages/Typography.vue'
import Icons from 'src/pages/Icons.vue'
import Maps from 'src/pages/Maps.vue'
import Notifications from 'src/pages/Notifications.vue'
import Upgrade from 'src/pages/Upgrade.vue'
import Login from 'src/pages/Login.vue'
import Logout from 'src/pages/Logout.vue'
import ForgotPassword from 'src/pages/ForgotPassword.vue'

const routes = [
  {
    path: '/login',
    component: Login,
        name: 'Login',
  },
  {
    path: '/logout',
    component: Logout,
        name: 'Logout',
  },
  {
    path: '/forgot-password',
    component: ForgotPassword,
    name: 'Forgot Password',
  },
  {
    path: '/',
    redirect: '/login'
  },
  {
    path: '/admin',
    component: DashboardLayout,
    redirect: '/admin/campaigns',
    children: [
      {
        path: 'overview',
        name: 'Overview',
        component: Overview
      },
      {
        path: 'create-client',
        name: 'Create Client',
        component: CreateClient,
      },
      {
        path: 'user',
        name: 'User',
        component: UserProfile
      },
      {
        path: 'create-user',
        name: 'Create User',
        component: CreateUser,
      },
      {
        path: 'create-campaign',
        name: 'Create Campaign',
        component: CreateCampaign,
      },
      {
        path: 'campaigns',
        name: 'Campaigns',
        component: Campaigns,
      },
      {
        path: 'campaigns/:campaignId',
        name: 'Campaign',
        component: Campaign,
        props: true 
      },
      {
        path: 'typography',
        name: 'Typography',
        component: Typography
      },
      {
        path: 'icons',
        name: 'Icons',
        component: Icons
      },
      {
        path: 'maps',
        name: 'Maps',
        component: Maps
      },
      {
        path: 'notifications',
        name: 'Notifications',
        component: Notifications
      },
      {
        path: 'upgrade',
        name: 'Upgrade to PRO',
        component: Upgrade
      }
    ]
  },
  { path: '*', component: NotFound }
]

/**
 * Asynchronously load view (Webpack Lazy loading compatible)
 * The specified component must be inside the Views folder
 * @param  {string} name  the filename (basename) of the view to load.
function view(name) {
   var res= require('../components/Dashboard/Views/' + name + '.vue');
   return res;
};**/

export default routes
